export default "__VITE_ASSET__60cbebcc__"